import deskService from '@/api/desk'
import { DESK } from '../types'
import strings from '@/strings'

export default {
  namespaced: true,
  state: {
    desks: [],
    desksCount: 0,
    pattern: '',
    availableDesks: [],
    desksPositions: [],
    desksBySite: []
  },
  getters: {
    desks: (state) => {
      return state.desks
    },
    desksCount: (state) => {
      return state.desksCount
    },
    pattern: (state) => {
      return state.pattern
    },
    patternDesksIsValid: (state) => {
      return state.pattern && state.pattern.length > 0 ? state.pattern.includes("#") : false
    },
    desksIsValid: (state, getters, rootState, rootGetters) => {
      return state.desksCount <= rootGetters['Client/clientDesksQuota']
    },
    everythingIsValid: (state, getters) => {
      return getters.patternDesksIsValid && getters.desksIsValid
    },
  },
  mutations: {
    [DESK.DESK_SET] (state, desks) {
      state.desks = desks
    },
    [DESK.DESKS_COUNT_SET](state, desksCount) {
      state.desksCount = desksCount
    },
    [DESK.PATTERN_SET](state, pattern) {
      state.pattern = pattern
    },
    [DESK.UPDATE_DESK] (state, desk) {
      state.desks.set(desk.id, desk)
    },
    [DESK.DESKS_POSITIONS] (state, desksPositions) {
      state.availableDesks = {}
      state.desksPositions = desksPositions
    },
    [DESK.DESKS_BY_SITE] (state, desksBySite) {
      state.desksBySite = desksBySite
    }
  },
  actions: {
    async getDesksBySite ({commit}, siteId) {
      let response = await deskService.getDesksBySite(siteId)
      commit(DESK.DESKS_BY_SITE, response.data)
    },
    // eslint-disable-next-line no-empty-pattern
    getAvailableDesks: function ({}, locationId) {
      return new Promise((resolve, reject) => {
        deskService.getAvailableDesks(locationId)
          .then((response) => {
            resolve(response.data)
          }).catch((error) => {
            reject(error)
          })
      })
    },
    // eslint-disable-next-line no-empty-pattern
    getDesksWithoutCamera: function ({}, params) {
      let clientId = params? params.clientId : undefined
      let locationId = params? params.locationId : undefined
      return new Promise((resolve, reject) => {
        deskService.getDesksWithoutCamera(locationId, clientId)
          .then((response) => {
            resolve(response.data)
          }).catch((error) => {
            reject(error)
          })
      })
    },
    // eslint-disable-next-line no-empty-pattern
    getDesksWithCamera: function ({}, params) {
      let cameraId = params? params.cameraId : undefined
       return new Promise((resolve, reject) => {
        deskService.getDesksWithCameraId(cameraId)
          .then((response) => {
            resolve(response.data)
          }).catch((error) => {
            reject(error)
          })
      })
    },
    getDesksPositions: function ({commit}, obj) {
      return new Promise((resolve, reject) => {
        deskService.getDesksPositions(obj.locationId, obj.clientId).then((response) => {
          commit(DESK.DESKS_POSITIONS, response.data)
          resolve(response.data)
        }).catch((error) => {
          reject(error)
        })
      })
    },
    async insertDesk({commit, state, dispatch, rootGetters}, desk ){
      let deskToChange = {
        active: state.desksCount >= rootGetters['Client/clientDesksQuota'] ? false : true,
        hasBookings: false,
        id: desk.feature.id_,
        locationId: desk.locationId,
        name: desk.nextDeskName,
        state: strings.pinStatus.inserted,
        x: desk.coordinates[0],
        y: desk.coordinates[1],
        bookable: true
      }
      if (deskToChange.active) {
        dispatch('updateDeskCount', state.desksCount + 1)
      }
      await commit(DESK.UPDATE_DESK, deskToChange)

    },
    updateTextDeskStore ({commit, state}, desk) {
      let deskToChange = state.desks.get(desk.id)
      deskToChange.name = desk.name
      if(deskToChange.state !== strings.pinStatus.inserted) {
        deskToChange.state = strings.pinStatus.updated
      }
      commit(DESK.UPDATE_DESK, deskToChange)
    },
    updateActiveDeskStore ({commit, state, dispatch}, desk) {
      let deskToChange = state.desks.get(desk.id)
      if (desk.active && !deskToChange.active) {
        dispatch('updateDeskCount', state.desksCount + 1)
      } else if(!desk.active && deskToChange.active) {
        dispatch('updateDeskCount', state.desksCount - 1)
      }
      deskToChange.active = desk.active
      if(deskToChange.state !== strings.pinStatus.inserted) {
        deskToChange.state = strings.pinStatus.updated
      }
      commit(DESK.UPDATE_DESK, deskToChange)
    },
    updateBookableDeskStore ({commit, state}, desk) {
      let deskToChange = state.desks.get(desk.id)
      deskToChange.bookable = desk.bookable
      if(deskToChange.state !== strings.pinStatus.inserted) {
        deskToChange.state = strings.pinStatus.updated
      }
      commit(DESK.UPDATE_DESK, deskToChange)
    },
    updateCoordinatesDeskStore({commit, state}, desk) {
      let selectedDesk = state.desks.get(desk.id)
      selectedDesk.state = selectedDesk.state === strings.pinStatus.inserted ? strings.pinStatus.inserted : strings.pinStatus.updated
      selectedDesk.x = desk.coordinates[0]
      selectedDesk.y = desk.coordinates[1]
      commit(DESK.UPDATE_DESK, selectedDesk)
    },
    updateDeskCount ({commit}, count) {
      commit(DESK.DESKS_COUNT_SET, count)
    },
    setPattern ({commit}, pattern){
      commit(DESK.PATTERN_SET, pattern)
    }
  }
}
